/**
 * TanStack Query hooks for `custom-tracking-domain-via-cname`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customTrackingDomainViaCnameQueryKeys,
	type CreateCustomTrackingDomainViaCnameBody,
	type ListCustomTrackingDomainViaCnameResponse,
	type CustomTrackingDomainViaCnameRow,
} from "./api";

export function useCustomTrackingDomainViaCnameList(): UseQueryResult<ListCustomTrackingDomainViaCnameResponse, Error> {
	return useQuery({
		queryKey: customTrackingDomainViaCnameQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomTrackingDomainViaCnameCreate(): UseMutationResult<CustomTrackingDomainViaCnameRow, Error, CreateCustomTrackingDomainViaCnameBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customTrackingDomainViaCnameQueryKeys.all });
		},
	});
}

export function useCustomTrackingDomainViaCnameDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customTrackingDomainViaCnameQueryKeys.all });
		},
	});
}
